import { floodDemoTimeIntensityFactors } from '@/features/map/utils/demoDataGenerator';

/**
 * Giờ 0–23 trong ngày `YYYY-MM-DD` mà tích `hourScale × seasonalScale` đạt cực đại.
 * Trong mô hình lưới demo hiện tại, hệ số này áp dụng **chung** mọi ô — giờ đỉnh giống nhau mọi vùng trong ngày.
 */
export function getGlobalPeakModelHourForCalendarDay(ymd: string): number {
  let bestH = 0;
  let best = -1;
  for (let h = 0; h < 24; h += 1) {
    const iso = `${ymd}T${String(h).padStart(2, '0')}:00:00`;
    const { hourScale, seasonalScale } = floodDemoTimeIntensityFactors(iso);
    const v = hourScale * seasonalScale;
    if (v > best) {
      best = v;
      bestH = h;
    }
  }
  return bestH;
}
